import { render, staticRenderFns } from "./AffidavitPersonalServicePOStep.vue?vue&type=template&id=8d3ac5a2"
import script from "./AffidavitPersonalServicePOStep.vue?vue&type=script&lang=ts"
export * from "./AffidavitPersonalServicePOStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports